import VisibilityIcon from '@material-ui/icons/Visibility';

export default VisibilityIcon;
